namespace TabAurous.Retail {
    export namespace GiftVoucherItemSelectService {
        export const baseUrl = 'Retail/GiftVoucherItemSelect';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GiftVoucherItemDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/GiftVoucherItemSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>GiftVoucherItemSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
